import type { SelectChangeEvent } from "@mui/material";
import type { FormType } from "./types";
import type { Dispatch, FC, SetStateAction } from "react";

import { Box } from "@mui/material";
import CustomDropdown from "./CustomDropdown";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { ChipAutocomplete } from "./ChipAutocomplete";

interface UrlPairingFormItemProps {
  index: number;
  form: FormType;
  dropdownItems: { value: string; title: string }[];
  hiddenValues: string[];
  handlePairingFormControlChange: (
    event: SelectChangeEvent,
    index: number,
    setForms: Dispatch<SetStateAction<FormType[]>>,
  ) => void;
  onDeletePairingForm: (
    index: number,
    setForms: Dispatch<SetStateAction<FormType[]>>,
  ) => void;
  onAddPairingFormIncludeChip: (
    index: number,
    value: string[],
    setForms: Dispatch<SetStateAction<FormType[]>>,
  ) => void;
  onAddPairingFormExcludeChip: (
    index: number,
    value: string[],
    setForms: Dispatch<SetStateAction<FormType[]>>,
  ) => void;
  setForms: Dispatch<SetStateAction<FormType[]>>;
  t: any;
  classes: Record<string, any>;
}

export const UrlPairingFormItem: FC<UrlPairingFormItemProps> = ({
  index,
  form,
  dropdownItems,
  hiddenValues,
  handlePairingFormControlChange,
  onDeletePairingForm,
  onAddPairingFormIncludeChip,
  onAddPairingFormExcludeChip,
  setForms,
  t,
  classes,
}) => {
  return (
    <Box className={classes.formContainer}>
      <Box className={classes.urlContainer}>
        <Box style={{ width: 280, marginBottom: 40 }}>
          <CustomDropdown
            label='URL'
            id={`${index}-form-dropdown`}
            value={form.control}
            items={dropdownItems}
            hiddenValues={hiddenValues}
            onChange={event =>
              handlePairingFormControlChange(event, index, setForms)
            }
          />
        </Box>
        <Box>
          <DeleteOutlineIcon
            onClick={() => onDeletePairingForm(index, setForms)}
            className={classes.icon}
          />
        </Box>
      </Box>
      <ChipAutocomplete
        id={`include-${index}`}
        label={t("campaign.settings.includes")}
        value={form.include || []}
        onChange={(_, value) => {
          onAddPairingFormIncludeChip(index, value as any, setForms);
        }}
      />
      <ChipAutocomplete
        id={`excludes-${index}`}
        label={t("campaign.settings.exclude")}
        value={form.excludes || []}
        onChange={(_, value) => {
          onAddPairingFormExcludeChip(index, value as any, setForms);
        }}
      />
    </Box>
  );
};
